module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-10.ccb3bd70.jpg";